<ng-container
  *ngIf="{ suscriptions: suscriptions$ | async, dailies: dailies$ | async, selectedSuscription: selectedSuscription$ | async } as vm"
>
  <ion-header>
    <ion-toolbar>
      <ion-title>Suscripciones</ion-title>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/tecservice-transportec/transportec" color="primary"></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <ion-segment mode="md" scrollable [value]="vm.selectedSuscription" *ngIf="vm.suscriptions?.length">
      <ion-segment-button
        *ngFor="let suscription of vm.suscriptions"
        [value]="suscription"
        (click)="selectSuscription(suscription)"
      >
        <ion-icon [src]="'/assets/icon/'+suscription.name.toLowerCase()+'.svg'"></ion-icon>
        <ion-label>
          {{suscription.slot_name}}
          <br />
          <span>{{suscription.name | subscriptionType }}</span>
        </ion-label>
      </ion-segment-button>
    </ion-segment>
    <div *ngFor="let item of vm.dailies">
      <ion-grid>
        <ion-row class="header">
          <ion-col>{{item.name}}</ion-col>
        </ion-row>
        <ng-template ngFor let-daily [ngForOf]="item.dailies" let-i="index">
          <ion-row class="header separator" *ngIf="i===5">
            <ion-col>{{item.name}} Exámenes</ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="4">{{daily.dotw}}</ion-col>
            <ion-col>
              {{daily.stop}}
              <br />
              <strong>Hora:</strong>
              {{daily.departureTime | slice: 0:5}}
            </ion-col>
          </ion-row>
        </ng-template>
      </ion-grid>
    </div>
  </ion-content>
</ng-container>
